import { OktonSimpleCrudForm } from '@okton/platform-ui';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import BankAppPage from '../../../layout/BankAppPage';
import {
  useCentrosCusto,
  useSaveCentroCusto,
} from '../../../services/hooks/useCadastros';

const CentroCustoForm = () => {
  const history = useHistory();
  const { idCentroCusto } = useParams<{ idCentroCusto?: string }>();
  const edicao = !!idCentroCusto;

  const { data: centrosCusto = [] } = useCentrosCusto();
  const saveMutation = useSaveCentroCusto();

  const [nome, setNome] = useState('');
  const [erro, setErro] = useState('');

  // A lista chega depois do primeiro render: sem isso a edição abriria vazia.
  useEffect(() => {
    const atual = centrosCusto.find(c => c.id_cdc === idCentroCusto);
    if (atual) {
      setNome(atual.nome_cdc);
    }
  }, [centrosCusto, idCentroCusto]);

  const salvar = async () => {
    if (!nome.trim()) {
      setErro('Informe o nome do Centro de Custo.');
      return;
    }
    setErro('');
    try {
      await saveMutation.mutateAsync({ id: idCentroCusto, nome: nome.trim() });
      history.push('/centros-custo');
    } catch (err) {
      setErro(
        err instanceof Error
          ? err.message
          : 'Erro ao gravar o Centro de Custo.',
      );
    }
  };

  return (
    <BankAppPage>
      <>
        <OktonSimpleCrudForm
          horizontalSpacing={0}
          title={edicao ? 'Editar Centro de Custo' : 'Novo Centro de Custo'}
          description="Classificação de custo dos lançamentos"
          onCancel={() => history.push('/centros-custo')}
          nameLabel="Nome"
          name={nome}
          onNameChange={setNome}
          maxName={60}
          error={erro}
          saving={saveMutation.isLoading}
          onSave={salvar}
        />
      </>
    </BankAppPage>
  );
};

export default CentroCustoForm;
